module.exports = __webpack_public_path__ + "img/za.a57b9a59.svg";